import { Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { take, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RouteService } from '../_services/route.service';
import * as i0 from "@angular/core";
import * as i1 from "../_services/auth.service";
import * as i2 from "@angular/router";
import * as i3 from "../_services/route.service";
export class AuthGuard {
    constructor(auth, router, authService, routeService) {
        this.auth = auth;
        this.router = router;
        this.authService = authService;
        this.routeService = routeService;
        this.messages = null;
    }
    canActivate(route, state) {
        return this.auth.user.pipe(take(1), map(user => {
            if (!user && environment.protected) {
                this.authService.setRedirectUrl(state.url);
                this.router.navigateByUrl(this.getRedirectUrl(route, state));
                return false;
            }
            else {
                return true;
            }
        }));
    }
    getToken(state) {
        let token = this.routeService.getQueryParam('token');
        if (token) {
            return token;
        }
        token = state.root.queryParams.token;
        return token ? token : null;
    }
    getRedirectUrl(route, state) {
        const token = this.getToken(state);
        let redirectUrl = this.router.url;
        if (redirectUrl === '/') {
            redirectUrl = '/' + route.url[0].path;
        }
        if (token) {
            redirectUrl = redirectUrl + '?token=' + token;
        }
        return redirectUrl;
    }
}
AuthGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i3.RouteService)); }, token: AuthGuard, providedIn: "root" });
